import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';

class DropDownChonKetQuaThucHien extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label="Kết quả thực hiện" isValid={this.props.isValid} bindValidator={this} channel="formTaoDon" require={this.props.require} selectedValue={this.props.selectedValue} options={this.props.data} keyName='giaTri' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={'col-input '+this.props.className} name="dropdownChonKetQuaThucHien"/>
    )
  }
}

DropDownChonKetQuaThucHien.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  }
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.ketQuaThucHien
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonKetQuaThucHien));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonketquathuchien.jsx